import 'intersection-observer';

(function($, Drupal){
  Drupal.behaviors.ourWork = {
    attach: function(context, settings) {
      let self = this;
      $(once('our-work-nav', '.path--our-work')).each(this.setup.bind(this));
      $(once('our-work-mobile-toggle', '.block-our-work-nav-block #mobile-toggle')).on('click', function(event) {
        event.preventDefault();
        self.toggleMobileNav();
      });
      $(once('our-work-nav-mobile', '.block-our-work-nav-block')).addClass('closed');
      this.addSmoothScrolling();
    },

    toggleMobileNav: function() {
      const ourWorkNav = $('.block-our-work-nav-block');
      if (ourWorkNav.hasClass('closed')) {
        ourWorkNav.removeClass('closed');
      } else {
        ourWorkNav.addClass('closed');
      }
    },

    addSmoothScrolling: function() {
      let self = this;
      $(once('our-work-smooth-scrolling', '.block-our-work-nav-block .menu a')).on('click', function(event) {
        event.preventDefault();
        let hash = this.hash;
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 800, function() {
           window.location.hash = hash;
        });
        self.toggleMobileNav();
      });
    },

    activateMenuItem(id) {
      if (id == null) {
        return;
      }
      const menuItems = $('.block-our-work-nav-block .menu a');
      menuItems.removeClass('active');
      const newActiveItem = $(this.idsToMenuItems[id]);
      const color = newActiveItem.attr('class');
      newActiveItem.addClass('active');
      const mobileToggle = $('.block-our-work-nav-block #mobile-toggle');
      mobileToggle.removeClass();
      mobileToggle.addClass(color);
    },

    getIdList: function() {
      const menuItems = $('.block-our-work-nav-block .menu a');
      const ids = [];
      for (const menuItem of menuItems) {
        let url = document.createElement('a');
        url.href = menuItem.href;
        let id = url.hash.substring(1);
        this.idsToMenuItems[id] = menuItem;
        ids.push(id);
      }
      return ids;
    },

    onIntersect: function(entries, observer) {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          this.activateMenuItem(entry.target.id);
        } else {
          if (entry.intersectionRect.top != 0) {
            this.activateMenuItem(entry.target.dataset.prevId);
          }
        }
      }
    },

    setup: function() {
      this.idsToMenuItems = {};
      this.setupMenuHighlights();
      const styles = {
        'position': 'relative',
        'z-index': 30,
      };
      $('.paragraph--type--up-next').parent().css(styles);
    },

    setupMenuHighlights() {
      const idList = this.getIdList();
      const options = {
        threshold: 0.5,
      };
      const observer = new IntersectionObserver(this.onIntersect.bind(this), options);
      let prevId = null;
      for (const id of idList) {
        const element = document.getElementById(id);
        observer.observe(element);
        if (prevId != null) {
          element.dataset.prevId = prevId;
        }
        prevId = id;
      }
    },
  };
  Drupal.behaviors.clientModal = {
    attach: function(context, settings) {
      let self = this;
      $(once('client-info-link-processed', 'a.client-info-link')).each(function() {
        // Add color classes to the modal link and modal wrapper elements.
        let modalClasses = self.getModalColorClasses(this);
        this.setAttribute('data-modal-class', modalClasses.join(' '));
        $(this).children('.client-info-loader').each(function() {
          this.setAttribute('data-modal-class', modalClasses.join(' '));
        });
        // Add a click handler for loading the modal before the lazy loader
        // has fetched the modal content. This is necessary for when the page
        // is still loading, if the user clicks a modal link.
        $(this).click(function(event) {
          event.preventDefault();
          const nodeId = $(this).data('client-id');
          const modalId = '#client-info-' + nodeId;
          if ($(modalId).children().length > 0) {
            $(modalId).modal();
          } else {
            $.get('/node/content/' + nodeId, function(html) {
              $(html).appendTo(modalId);
              $(modalId).modal();
            });
          }
        });
      });
      self.getClientQueryParam();
      self.maybeScrollToClient();
      self.initLazyLoader();
    },
    maybeScrollToClient: function() {
      if (this.clientQueryParam !== null) {
        $('html, body').animate({ 
          scrollTop: ($('a.' + this.clientQueryParam).first().offset().top)
        }, 500);
      }
    },
    initLazyLoader: function() {
      let self = this;
      $('.client-info-loader').Lazy({
        visibleOnly: true,
        afterLoad: function(element) {
          let link = $(element.parent());
          link.off('click');
          link.data('modal', '#' + element[0].id);
          link.removeAttr('rel');
          link.click(function(event) {
            event.preventDefault();
            $($(this).data('modal')).modal();
          });
          if (self.clientQueryParam !== null && link.hasClass(self.clientQueryParam)) {
            $($(link).data('modal')).modal();
          }
        },
      });
    },
    getModalColorClasses: function(element) {
      let modalClasses = ['modal'];
      let paragraph = $(element).closest('.paragraph');
      paragraph[0].classList.forEach(function(value, index, classes) {
        if (value.startsWith('color-')) {
          modalClasses.push(value);
        }
      });
      return modalClasses;
    },
    clientQueryParam: null,
    getClientQueryParam: function() {
      const urlParams = new URLSearchParams(window.location.search);
      this.clientQueryParam = urlParams.get('client');
    }
  };
})(jQuery, Drupal);
